import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useEffect, useState } from "react"
import { useOptimisticTailoringAudit } from "./hooks/use-optimistic-tailoring-audit"

export function TailoredAudit({ children }) {
    const { task, tailoredAudits, taskTailored } = useBoundContext()
    const [justification, setJustification] = useState(null)

    const [audit, setTailoringAudit] = useOptimisticTailoringAudit(tailoredAudits?.[task?.id])

    useEffect(() => {
        if (!taskTailored) {
            setJustification(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTailored])

    return (
        <Bound
            tailoringAudit={audit}
            setTailoringAudit={setTailoringAudit}
            justification={justification}
            setJustification={setJustification}
        >
            {children}
        </Bound>
    )
}
